export const size = {
    md: 768,
    lg: 1170
}

export const device = {
    md: `(min-width: ${size.md}px)`,
    lg: `(min-width: ${size.lg}px)`
}

export const unit = {
    
    sm: {
        margin: 6.03,
        menuHeight: 7.72,
        fullWidthMenuHeight: 11.35
    },
    md: {
        horizontalMargin: 3.02,
        verticalMargin: 1.84,
        menuHeight: 2.5,
        fullWidthMenuHeight: 12.37
    }

}